import React, { useEffect } from "react";

const ImageSerene = ({ images, currentIndex, onClose, onNext, onPrev }) => {
  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowRight") onNext();
      if (e.key === "ArrowLeft") onPrev();
    };
    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [onClose, onNext, onPrev]);

  if (currentIndex === null) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(0,0,0,0.9)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
      }}
      onClick={onClose}
    >
      {/* Close */}
      <button
        onClick={onClose}
        style={{
          position: "absolute",
          top: "20px",
          right: "30px",
          background: "none",
          border: "none",
          fontSize: "2rem",
          color: "#fff",
          cursor: "pointer",
        }}
      >
        ✕
      </button>

      {/* Left */}
      <button
        onClick={(e) => {
          e.stopPropagation();
          onPrev();
        }}
        style={{
          position: "absolute",
          left: "30px",
          background: "none",
          border: "none",
          fontSize: "2.5rem",
          color: "#fff",
          cursor: "pointer",
        }}
      >
        ‹
      </button>

      {/* Image */}
      <img
        src={images[currentIndex]}
        alt={`Serene ${currentIndex}`}
        style={{
          maxWidth: "90%",
          maxHeight: "85%",
          objectFit: "contain",
          borderRadius: "8px",
          boxShadow: "0 4px 20px rgba(0,0,0,0.5)",
        }}
        onClick={(e) => e.stopPropagation()}
      />

      {/* Right */}
      <button
        onClick={(e) => {
          e.stopPropagation();
          onNext();
        }}
        style={{
          position: "absolute",
          right: "30px",
          background: "none",
          border: "none",
          fontSize: "2.5rem",
          color: "#fff",
          cursor: "pointer",
        }}
      >
        ›
      </button>

      {/* Dots */}
      <div
        style={{
          position: "absolute",
          bottom: "20px",
          left: "50%",
          transform: "translateX(-50%)",
          display: "flex",
          gap: "8px",
        }}
      >
        {images.map((_, idx) => (
          <div
            key={idx}
            style={{
              width: "10px",
              height: "10px",
              borderRadius: "50%",
              backgroundColor:
                idx === currentIndex ? "#fff" : "rgba(255,255,255,0.3)",
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default ImageSerene;
